import { useState } from 'react';

const navItems = [
  { label: '情报速览', href: '#hero' },
  { label: '个人资料', href: '#profile' },
  { label: '话题墙', href: '#topics' },
  { label: '最新爆料', href: '#leaks' },
  { label: '合集索引', href: '#collections' },
  { label: '吃瓜社区', href: '#community' },
];

const tips = [
  '本站内容为网友整理的公开讨论汇总，仅供吃瓜浏览',
  '最新爆料持续补档，收藏首页不迷路',
  '争议话题请理性讨论，注意辨别信息来源',
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="flex h-9 items-center overflow-hidden border-b border-primary-900 bg-primary-950 text-background-100">
        <span className="flex h-full shrink-0 items-center gap-1.5 bg-accent-500 px-3 text-[11px] font-bold text-primary-950">
          <i className="ri-megaphone-line text-sm" aria-hidden="true" />
          公告
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track flex w-max whitespace-nowrap">
            {[...tips, ...tips].map((tip, index) => (
              <span key={index} className="mx-6 text-[12px] tracking-wide text-background-200">
                {tip}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="border-b border-background-200 bg-background-50/95 backdrop-blur-md">
        <div className="flex h-16 w-full items-center justify-between gap-4 px-4 md:px-8">
          <a href="#hero" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-fire-line text-lg" aria-hidden="true" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-base font-bold tracking-wide text-foreground-950">
                风间由美
              </span>
              <span className="font-label text-[10px] tracking-[0.28em] text-primary-600">
                情报总站
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#community"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
            >
              加入追更
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((prev) => !prev)}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true" />
            </button>
          </div>
        </div>

        {open && (
          <nav className="border-t border-background-200 bg-background-50 px-4 py-2 md:hidden" aria-label="移动导航">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="block rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#community"
              onClick={() => setOpen(false)}
              className="mt-1 block rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50"
            >
              加入追更
            </a>
          </nav>
        )}
      </div>
    </header>
  );
}